import { Link, navigate } from 'gatsby'
import React, { useContext } from 'react'

import { LocaleContext } from '../../../locale/i18n'
import { staticPagePaths } from '../../../locale/pathing'
import { StaticPage } from '../../../logic/staticPage'
import Button from '../../Button'
import IconCircledCheck from '../../icons/IconCircledCheck'

const AddedToCart = ({
  onClose,
  hasParameters,
}: {
  onClose: () => void
  hasParameters: boolean
}) => {
  const { t, locale } = useContext(LocaleContext)

  return (
    <div
      className="rounded-lg border border-gray-300 text-sm sm:text-base"
      data-test-id="msg-added-to-cart"
    >
      <div className="flex flex-col items-center gap-6 px-6 py-9">
        <IconCircledCheck width="36" height="36" />
        <h4 className="text-center font-primary text-lg font-semibold">
          {t('productPage.productConfiguration.addedToCart.heading')}
        </h4>
        <Button
          size="xl"
          onClick={() => navigate(staticPagePaths[StaticPage.CART][locale])}
        >
          {t('productPage.productConfiguration.addedToCart.proceed')}
        </Button>
        {hasParameters ? (
          <Button variant="link" onClick={() => onClose()}>
            {t(
              'productPage.productConfiguration.addedToCart.buyDifferentOptions',
            )}
          </Button>
        ) : null}
        <Link to={staticPagePaths[StaticPage.PRODUCTS][locale]}>
          {t('productPage.productConfiguration.addedToCart.buyOther')}
        </Link>
      </div>
    </div>
  )
}

export default AddedToCart
